import { OperationReportRoutes } from "./routes"

export const OperationReportPage = () => {
    return <OperationReportRoutes />
}
